import { createSlice } from '@reduxjs/toolkit';

// When the fix is from, as a number, so two rows for one vehicle can be compared. A row whose
// fixTime will not parse sorts below any row that has one, rather than winning by arriving late.
const at = (position) => {
  const parsed = Date.parse(position?.fixTime);
  return Number.isFinite(parsed) ? parsed : -Infinity;
};

const { reducer, actions } = createSlice({
  name: 'positions',
  initialState: {
    items: {},
  },
  reducers: {
    // The authorised set, entire. The positions endpoint answers with every vehicle this account may
    // see, so a vehicle missing from it is a vehicle that must stop being shown - which is precisely
    // what happens when a tracking entitlement ends. Merging kept the last known coordinates on the
    // map until somebody reloaded, so the one case redaction exists for was the one the client
    // ignored. Newest-wins still applies within the payload, for the duplicate rows below.
    replace(state, action) {
      const fresh = {};
      action.payload.forEach((item) => {
        const held = fresh[item.deviceId];
        if (!held || at(item) >= at(held)) fresh[item.deviceId] = item;
      });
      state.items = fresh;
    },
    update(state, action) {
      // Keep the newest fix per vehicle rather than whichever arrived last.
      //
      // The server lists records newest id first, so a plain last-wins assignment kept the row with
      // the LOWEST id. A vehicle carrying two position rows - which nothing in the store prevents -
      // therefore showed the older one, and one truck sat at "Quiet 7 d" on the live screen while a
      // fix from a minute earlier was in the same payload, ignored.
      action.payload.forEach((item) => {
        const held = state.items[item.deviceId];
        if (!held || at(item) >= at(held)) state.items[item.deviceId] = item;
      });
    },
  },
});

export { actions as positionsActions };
export { reducer as positionsReducer };
